<footer id="footer">
    <div class="container">
        <div class="footer-upper section-pd-sm pb-20">
            <div class="row">
                <div class="col-lg-6 col-12">
                    <div class="footer-widget">
                        <h3>關於 Trinka</h3>
                        <p>
                            Trinka AI 是一款專為學術與技術寫作設計的AI 寫作助手，重視作者的隱私安全，提供先進的文法檢查與語言潤飾功能。
                            它能幫助專業人士與研究人員寫出更正式、精準的內容。企業方案則提供全方位功能、多元整合及高度資料控管，可彈性客製，提升團隊寫作效率與影響力。
                        </p>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="footer-widget">
                        <h3>在以下程式中使用:</h3>
                        <ul class="install-for">
                            <li>
                                <div class="install-in-browser">
                                    <a href="/wordplugin">
                                        <div class="icon text-center">
                                            <img src="assets/images/NewWordAdd_in.svg" width="47" height="42" alt="word in - grammar checker" />
                                        </div>
                                        <span>微軟Word (Windows)</span>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <a href="/browser-plugin">
                                        <div class="icon text-center">
                                            <img src="assets/images/NewChromeFicon.svg" width="43" height="42" alt="word in - grammar checker" />
                                        </div>
                                        <span>Google Chrome</span>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <a href="/browser-plugin">
                                        <div class="icon text-center">
                                            <img src="assets/images/NewFirefoxFicon.svg" width="42" height="42" alt="word in - grammar checker" />
                                        </div>
                                        <span>Mozilla Firefox</span>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <a href="/browser-plugin">
                                        <div class="icon text-center">
                                            <img src="assets/images/EdgeWhite_BGAndOutline.svg" width="42" height="42" alt="word in - grammar checker" />
                                        </div>
                                        <span>Microsoft Edge</span>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <a href="/wordplugin-lite">
                                        <div class="icon text-center">
                                            <img src="assets/images/NewWordAdd_in.svg" width="47" height="42" alt="word in - grammar checker" />
                                        </div>
                                        <span>Mac版Word</span>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="install-in-browser">
                                    <a href="/windows-desktop-app">
                                        <div class="icon text-center">
                                            <img src="assets/images/windows.png" width="42" height="42" alt="windows app - grammar checker" />
                                        </div>
                                        <span>Windows App</span>
                                    </a>
                                </div>
                            </li>
                        </ul>
                        <app-subscribe-form></app-subscribe-form>
                    </div>
                </div>
            </div>
            <div class="footer-grid">
                <div class="row">
                    <div class="col-6 col-sm-4 col-1">
                        <div class="footer-widget">
                            <h3>公司介紹</h3>
                            <ul class="ftr-menu">
                                <li>
                                    <a href="/aboutus">關於我們</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/contactus']">聯繫我們</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/workwithus']">加入我們</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/affiliates']">聯盟行銷</a>
                                </li>
                                <!-- <li>
                                    <a [routerLink]="['/campus-ambassador']" routerLinkActive="active">Ambassador Program</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/news']" routerLinkActive="active">News</a>
                                </li> -->
                                <li>
                                    <a href="/data-security" routerLinkActive="active">資料安全</a>
                                </li>
                            </ul>
                        </div>
                        <div class="footer-widget">
                            <h3>學到更多</h3>
                            <ul class="ftr-menu">
                                <li>
                                    <a [routerLink]="['/examples']">範例</a>
                                </li>
                                <li>
                                    <a href="/faqs">常見問答</a>
                                </li>
                                <li>
                                    <a href="https://developer.trinka.ai/docs/getting-started" target="_blank">Developer Docs</a>
                                </li>
                                <!-- <li>
                                    <a href="/eu-ai-act-compliance">EU AI Act</a>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                    <div class="col-6 col-sm-4 col-2">
                        <div class="footer-widget">
                            <h3>特色</h3>
                            <ul class="ftr-menu">
                                <li>
                                    <a [routerLink]="['/features']">所有功能</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/grammar-checker']">文法檢查</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/proofread-file']">自動文件編輯</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/latex-grammar-checker']">LaTeX 文件校對</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/paraphraser']">文章改寫</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/ai-studio/ai-writing-tools']">AI 寫作工具</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/ai-studio/ai-assisted-writing']">AI 智慧寫作助手</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/consistency-check']">一致性檢查</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/inclusive-language-check']">中性語言檢查</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/plagiarism-check']">抄襲檢測</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/ai-content-detector']">AI 內容檢測工具</a>
                                </li>
                                <!-- <li>
                                    <a [routerLink]="['/features/technical-checks']">Technical Checks</a>
                                </li> -->
                                <li>
                                    <a [routerLink]="['/features/citation-checker']">引文檢查器</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/citation-formatter']">引文格式整理器</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/journal-finder']">期刊查找</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/legal-writing']">法律寫作</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/personal-dictionary']">個人詞典</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/features/credits']">Trinka積分</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-4 col-3">
                        <div class="row">
                            <div class="col-sm-12 col-6">
                                <div class="footer-widget">
                                    <h3>企業</h3>
                                    <ul class="ftr-menu">
                                        <li>
                                            <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']">生命科學、醫療與製藥產業</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/language-services-publishing-and-media']">語言服務、出版與媒體</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/academic-institutions']">機構方案</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/k12-and-elearning']">K-12 及線上學習方案</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/technology-platforms']">科技與軟體</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/sensitive-data-plan']">敏感資料方案</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise']">Trinka 企業版</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/grammar-checker-api']">文法檢查 API</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/local-invoice']">發票與付款</a>
                                        </li>
                                        <!-- <li>
                                            <a [routerLink]="['/windows-desktop-app/offline-grammar-checker']">Offline Grammar Checker</a>
                                        </li> -->
                                        <li>
                                            <a [routerLink]="['/features/documark']">DocuMark</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-sm-12 col-6">
                                <div class="footer-widget">
                                    <h3>客製化 AI 模型</h3>
                                    <ul class="ftr-menu">
                                        <li>
                                            <a [routerLink]="['/enterprise/custom-ai-models/overview']">概覽</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/custom-ai-models/how-we-do-it']">我們的運作方式</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/custom-ai-models/process']">流程</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/custom-ai-models/why-choose-us']">為何選擇 Trinka？</a>
                                        </li>
                                        <li>
                                            <a [routerLink]="['/enterprise/custom-ai-models/rlhf']">RLHF 技術介紹</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-4">
                        <div class="row">
                            <div class="col-md-6 col-sm-4 col-12">
                                <div class="row">
                                    <div class="col-6 col-sm-12">
                                        <div class="footer-widget">
                                            <h3>競品比較</h3>
                                            <ul class="ftr-menu">
                                                <li>
                                                    <a href="/trinka-vs-grammarly">Trinka vs. Grammarly</a>
                                                </li>
                                                <li>
                                                    <a href="/trinka-vs-ginger">Trinka vs. Ginger</a>
                                                </li>
                                                <li>
                                                    <a href="/trinka-vs-languagetool">Trinka vs. LanguageTool</a>
                                                </li>
                                                <li>
                                                    <a href="/trinka-vs-writefull">Trinka vs. Writefull</a>
                                                </li>
                                                <!-- <li>
                                                    <a href="/trinka-vs-quillbot">Trinka vs. Quillbot</a>
                                                </li> -->
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-12">
                                        <div class="footer-widget">
                                            <h3>Resources</h3>
                                            <ul class="ftr-menu">
                                                <li>
                                                    <a href="/case-study">案例研究</a>
                                                </li>
                                                <!-- <li>
                                                    <a href="https://www.trinka.ai/blog/"  target="_blank">Blog</a>
                                                </li>
                                                <li>
                                                    <a href="https://www.trinka.ai/blog/category/writing-tips/"  target="_blank">Writing Tips</a>
                                                </li> -->
                                                <!-- <li>
                                                    <a href="/podcast">Podcast</a>
                                                </li>
                                                <li>
                                                    <a href="/webinars">Webinars</a>
                                                </li>
                                                <li>
                                                    <a href="/videos">Videos</a>
                                                </li> -->
                                                <li>
                                                    <a href="/trinka-vs-grammarly-vs-language-tool">白皮書</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-8 col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="footer-widget">
                                            <h3>免費工具</h3>
                                            <ul class="ftr-menu tools-menu">
                                                <li>
                                                    <a href="/grammar-checker">文法檢查</a>
                                                </li>
                                                <li>
                                                    <a href="/paraphrasing-tool">文章改寫工具</a>
                                                </li>
                                                <li>
                                                    <a href="/journal-finder">期刊查找</a>
                                                </li>
                                                <li>
                                                    <a href="/ai-content-detector">AI 內容檢測工具</a>
                                                </li>
                                                <li>
                                                    <a href="/punctuation-checker">標點符號檢查工具</a>
                                                </li>
                                                <li>
                                                    <a href="/spell-checker">拼寫檢查工具</a>
                                                </li>
                                                <li>
                                                    <a href="/sentence-checker">句子檢查工具</a>
                                                </li>
                                                <!-- <li>
                                                    <a href="/essay-checker">Essay Checker</a>
                                                </li>
                                                <li>
                                                    <a href="/medical-grammar-and-spelling-checker">Medical Grammar Check</a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/academic-phrasebank']">Academic Phrasebank</a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/thesis-checker']">Thesis Checker</a>
                                                </li>
                                                <li>
                                                    <a href="/ai-editing">AI Editing</a>
                                                </li>
                                                <li>
                                                    <a [routerLink]="['/free-proofreading-tools']" >AI Proofreading Tools</a>
                                                </li> -->
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="footer-widget">
                                    <h3>Compliances Covered</h3>
                                    <ul class="complianceCovered">
                                        <li>
                                            <img src="assets/images/Hipaa-logo.svg" width="119" height="119" alt="Hippa" />
                                        </li>
                                        <li>
                                            <img src="assets/images/EU_AI_Act.png" width="113" height="112" alt="EU AI Act" />
                                        </li>
                                        <li>
                                            <img src="assets/images/SOC-2.webp" width="113" height="112" alt="SOC 2" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificate5.svg" width="113" height="112" alt="GDPR" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificate1.svg" width="113" height="112" alt="iso 270001:2013 information security certificate" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificate2.svg" width="113" height="112" alt="iso 9001:2015 quality certificate" />
                                        </li>
                                        <li>
                                            <img src="assets/images/compliance-certificate4.svg" width="113" height="112" alt="ada certificate" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-middle section-pd-sm pb-20">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="footer-widget">
                        <h3>技術支援：</h3>
                        <div class="media">
                            <div class="media-left">
                                <img src="assets/images/enago-logo.png" alt="enago" width="140" height="40" />
                            </div>
                            <div class="media-body">
                                <p>Enago是深受全球研究界信賴的作者服務品牌，已幫助125多個國家/地區的研究人員促進研究交流並成功發表。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="footer-widget">
                        <h3>英論閣服務</h3>
                        <ul class="ftr-menu ftr-services">
                            <li>
                                <a href="https://www.enago.com/" target="_blank">英文編輯</a>
                            </li>
                            <li>
                                <a href="https://www.enago.com/publication-support-services" target="_blank">出版協助</a>
                            </li>
                            <li>
                                <a href="https://www.ulatus.com/" target="_blank">翻譯服務</a>
                            </li>
                            <li>
                                <a href="https://www.enago.com/plagiarism-checker/" target="_blank">Plagiarism and Auto Grammar Check</a>
                            </li>
                            <li>
                                <a href="https://www.voxtab.com/" target="_blank">轉錄和字幕服務</a>
                            </li>
                            <li>
                                <a href="https://lifesciences.enago.com/" target="_blank">全球醫療通訊</a>
                            </li>
                            <li>
                                <a href="https://www.read.enago.com/" target="_blank">文獻回顧與分析工具</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="footer-copyright">
            <div class="cp-left align-items-center">
                <p>© Crimson AI, {{ latestYear }}. Made in India.</p>
                <ul class="align-items-center">
                    <li>
                        <a href="mailto:support@trinka.ai">support&#64;trinka.ai</a>
                    </li>
                    <li>
                        <a id="PrivacyButton" href="https://www.trinka.ai/privacypolicy" target="_blank">隱私政策</a>
                    </li>
                    <li>
                        <a id="termsofserviceButton" href="https://www.trinka.ai/termsofservices" target="_blank">服務條款</a>
                    </li>
                </ul>
            </div>
            <div class="cp-right">
                <div class="footer-widget mb-0 follow-us">
                    <h3 class="mb-0">關注我們:</h3>
                    <ul class="align-items-center">
                        <li>
                            <a href="https://www.facebook.com/thetrinkaai/" rel=" no referer, no opener" aria-label="facebook" target="_blank">
                                <img src="assets/images/social-media/facebook.svg" width="15" height="15" alt="facebook" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/thetrinkaai/" rel=" no referer, no opener" aria-label="instagram" target="_blank">
                                <img src="assets/images/social-media/instagram.svg" width="15" height="15" alt="instagram" />
                            </a>
                        </li>
                        <li>
                            <a href="https://x.com/thetrinkaai" rel=" no referer, no opener" aria-label="twitter" target="_blank">
                                <img src="assets/images/social-media/twitter-logo.svg" width="15" height="14" alt="twitter" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/thetrinkaai" rel=" no referer, no opener" aria-label="linkedin" target="_blank">
                                <img src="assets/images/social-media/linkedin.svg" width="15" height="15" alt="linkedin" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA" rel=" no referer, no opener" aria-label="youtube" target="_blank">
                                <img src="assets/images/social-media/youtube.svg" width="15" height="15" alt="youtube" />
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="language_sections" id="languageDropDown">
                    <i class="fa fa-globe" aria-hidden="true"></i>
                    <span>繁體中文</span>
                    <ul class="drop">
                        <li>
                            <a href="https://www.trinka.ai/">English</a>
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/jp/">
                                日本語
                            </a>
                        </li>
                        <li>
                            <a href="https://trinka.enago.cn/">
                                简体中文
                            </a>
                        </li>
                        <li class="selected">
                            <i class="fa fa-check" aria-hidden="true"></i>
                            <a href="https://www.trinka.ai/tw/">
                                繁體中文
                            </a>
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/kr/">
                                한국어
                            </a>
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/es/">
                                Español
                            </a>
                        </li>
                        <li>
                            <a href="https://www.trinka.ai/pt/">
                                Português
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>
